import React, { memo } from 'react';
import { Heart, Globe2 } from 'lucide-react';
export function WhyReadThis() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 relative" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        {/* Header */}
        <div className="text-center mb-16 flex flex-col items-center gap-6" data-id="element-274">
          {/* Top gradient divider */}
          <div className="h-px w-32 bg-gradient-to-r from-transparent via-[#d4a85a] to-[#DC2626]" data-id="element-275" />

          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-276">
            A Book for Everyone
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-277">
            Why read this story?
          </h2>

          {/* Bottom gradient divider */}
          <div className="h-px w-32 bg-gradient-to-r from-[#DC2626] via-[#d4a85a] to-transparent" data-id="element-278" />
        </div>

        {/* Two-column card layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-279">
          {/* Left Card — FOR VENEZUELANS */}
          <div className="relative bg-[#111] border border-gray-800 rounded-lg p-8 sm:p-10 overflow-hidden group hover:border-[#DC2626]/40 transition-colors" data-id="element-280">
            {/* Left edge gradient glow */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#DC2626] to-transparent opacity-70" data-id="element-281" />
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#DC2626]/10 to-transparent pointer-events-none" data-id="element-282" />

            <div className="relative z-10 flex flex-col gap-5" data-id="element-283">
              <div className="w-14 h-14 rounded-full bg-[#DC2626]/10 border border-[#DC2626]/30 flex items-center justify-center" data-id="element-284">
                <Heart className="w-6 h-6 text-[#DC2626]" strokeWidth={1.5} data-id="element-285" />
              </div>

              <div data-id="element-286">
                <p className="text-[#DC2626] uppercase tracking-[0.18em] text-[11px] font-bold mb-1" data-id="element-287">
                  For Venezuelans
                </p>
                <h3 className="font-serif text-2xl sm:text-[26px] text-[#e8e2d4] font-normal leading-tight" data-id="element-288">
                  Your history, your memory
                </h3>
              </div>

              <p className="text-gray-400 text-base leading-relaxed" data-id="element-289">
                Reclaim the memory, understand the betrayal, and visualize the
                justice we all expect for 2026.
              </p>
            </div>
          </div>

          {/* Right Card — FOR THE WORLD */}
          <div className="relative bg-[#111] border border-gray-800 rounded-lg p-8 sm:p-10 overflow-hidden group hover:border-blue-500/40 transition-colors" data-id="element-290">
            {/* Left edge gradient glow */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-blue-500 to-transparent opacity-70" data-id="element-291" />
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-blue-500/10 to-transparent pointer-events-none" data-id="element-292" />

            <div className="relative z-10 flex flex-col gap-5" data-id="element-293">
              <div className="w-14 h-14 rounded-full bg-blue-500/10 border border-blue-500/30 flex items-center justify-center" data-id="element-294">
                <Globe2 className="w-6 h-6 text-blue-400" strokeWidth={1.5} data-id="element-295" />
              </div>

              <div data-id="element-296">
                <p className="text-blue-400 uppercase tracking-[0.18em] text-[11px] font-bold mb-1" data-id="element-297">
                  For the World
                </p>
                <h3 className="font-serif text-2xl sm:text-[26px] text-[#e8e2d4] font-normal leading-tight" data-id="element-298">
                  A lesson not to be repeated
                </h3>
              </div>

              <p className="text-gray-400 text-base leading-relaxed" data-id="element-299">
                Discover the geopolitical tactics, international power networks,
                and the historical lesson that no one should ignore.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}